import { render, staticRenderFns } from "./ShippingReturnFormV2.vue?vue&type=template&id=84e48a72&scoped=true&"
import script from "./ShippingReturnFormV2.vue?vue&type=script&lang=js&"
export * from "./ShippingReturnFormV2.vue?vue&type=script&lang=js&"
import style0 from "./ShippingReturnFormV2.vue?vue&type=style&index=0&id=84e48a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e48a72",
  null
  
)

export default component.exports